module.exports = __webpack_public_path__ + "media/images/tiedye/design-4-590a7537a29ac31892e3620d2b6816c3.jpg";